import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5570acc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "side-bar" }
const _hoisted_2 = { class: "list" }
const _hoisted_3 = { class: "list-item" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "list-item" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "list-item" }
const _hoisted_10 = { class: "list-item" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["innerHTML"]

import {
  ref, onMounted, onUnmounted, computed,
} from 'vue';
import qs from 'qs';
import moment from 'moment';
import { useStore, } from 'vuex';
import menuConfig from '@/configs/menuCongifg';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
// 请求数据结束时间
const EndTime = ref(moment().format('YYYYMMDDHHmmss'));
// 请求数据开始时间
const StartTime = ref(
  moment(EndTime.value, 'YYYYMMDDHHmmss')
    .add(-3, 'days')
    .format('YYYYMMDD000000')
);

// 展开数据源名称
const openName = ref<string>('point');
// 数据源(父级)type类型
const sourceType = ref<number>(1);

// AQI城市排名（获取最新站点时间）
const AQIList = computed(() => store.state.gateway.AQICountryRankingList);

// 选中要素高亮
const activeItem = ref<string>('pmPM25');
// 选中要素的indexName
const legendName = ref('PM25');

// 获取播放轴时间
const getPlayTimeLength = () => {
  const key = sourceType.value;

  if (key === 0 || key === 1 || key === 2) {
    const endTime = moment(AQIList.value[0]?.reportTime, 'YYYYMMDDHH').format('YYYYMMDDHH00');
    const beginTime = moment(endTime, 'YYYYMMDDHHmm')
      .add(-3, 'days')
      .format('YYYYMMDD0000');

    const params = {
      beginTime,
      endTime,
    };

    store.commit('layerConsole/setPlayTime', params);
  } else if (key === 3) {
    const currentTime = moment(AQIList.value[0]?.reportTime, 'YYYYMMDDHH').format('YYYYMMDD2300');
    const beginTime = moment(currentTime, 'YYYYMMDDHHmm')
      .add(-3, 'days')
      .format('YYYYMMDD0000');
    const endTime = moment(currentTime, 'YYYYMMDDHHmm')
      .add(3, 'days')
      .format('YYYYMMDD2300');

    const params = {
      beginTime,
      endTime,
    };

    store.commit('layerConsole/setPlayTime', params);
  }
};

// 获取气象数据数据
const getWeatherIssues = () => {
  const currentTime = moment().format('YYYYMMDD');
  const endTime = moment(currentTime, 'YYYYMMDDHH')
    .add('3', 'days')
    .format('YYYYMMDD23');
  const startTime = moment(currentTime, 'YYYYMMDDHH')
    .add('-3', 'days')
    .format('YYYYMMDD00');
  const param = {
    startTime,
    endTime,
  };
  const params = {
    param,
    type: legendName.value,
  };

  store.dispatch('layerConsole/getWeatherIssues', params);
};

/**
 * 环境站点和时间轴联动列表接口请求
 * @param {any} params 开始结束时间入参
 * @returns {void}
 */
const loadStationData = (params: any) => {
  store.dispatch('layerConsole/getEnvDatasForTimes', {
    params,
    callback: (val:any) => {
      //
    },
  });
};

/**
 * 点击数据源
 * @param {string} name  高亮参数
 * @param {string} key 选中父项的type
 * @return {void}
 */
const handleOpen = (name: string, key: number): void => {
  if (openName.value === name) {
    openName.value = '';
    sourceType.value = -1;
  } else {
    openName.value = name;
    sourceType.value = key;
  }

  // 每次展开清空要素
  activeItem.value = '';
  legendName.value = '';
  store.commit('layerConsole/setIndexName', '');
  store.commit('layerConsole/setProductData3D', {});

  // 要素（父项）
  store.commit('layerConsole/setType', sourceType.value);
  // 要素（子项）
  store.commit('layerConsole/setIndexName', legendName.value);

  if (key === 1 || key === 0) {
    // 环境站点加载
    const stationParams = {
      startTime: moment(moment().format('YYYYMMDDHH'), 'YYYYMMDDHH').add(-1, 'hour').format('YYYYMMDDHH'),
      endTime: moment().format('YYYYMMDDHH'),
    };

    loadStationData(stationParams);

    // 默认加载
    const activeParam = key === 0 ? 'satellitePM25' : 'pmPM25';

    // eslint-disable-next-line
    handleItemClick(activeParam,'PM25');
  } else if (key === 2) {
    store.commit('layerConsole/setIndexName', name);
    getPlayTimeLength();
  } else if (key === 3) {
    // 气象站点加载
    store.dispatch('layerConsole/getWeatherStationList', { regionId: '', });

    // 默认加载
    // eslint-disable-next-line
    handleItemClick('TEM','TEM');
  }
};

/**
 * 点击要素
 * @param {string} param  高亮参数
 * @param {string} indexName 选中子项的indexName
 * @return {void}
 */
const handleItemClick = (param: string, indexName: string) => {
  if (activeItem.value === param) {
    activeItem.value = '';
    legendName.value = '';
    store.commit('layerConsole/setIndexName', '');
    store.commit('layerConsole/setProductData3D', {});
  } else {
    activeItem.value = param;
    legendName.value = indexName;
    // 要素（子项）
    store.commit('layerConsole/setIndexName', legendName.value);
    getPlayTimeLength();

    if (sourceType.value === 0 || sourceType.value === 1) {
      const endTime = moment().format('YYYYMMDDHH');
      const startTime = moment().add(-3, 'days').format('YYYYMMDD00');
      const params = {
        startTime: moment().subtract(1, 'hour').format('YYYYMMDD0000'),
        endTime: moment().format('YYYYMMDDHHmm'),
        indexName,
        type: sourceType.value,
        queryType: 1,
      };
      const params2 = {
        startTime,
        endTime,
      };

      store.dispatch('layerConsole/getHistoryData', params);
      store.dispatch('layerConsole/getStationListForTimes', { params: params2, dimension: '3D', });
      store.dispatch('layerConsole/getWindyIssues', params2);
    }

    if (sourceType.value === 3) {
      getWeatherIssues();

      const endTime = moment().format('YYYYMMDDHH');
      const startTime = moment().add(-3, 'days').format('YYYYMMDD00');
      const params2 = {
        startTime,
        endTime,
      };

      store.dispatch('layerConsole/getWeatherStationListForTimes', { params: params2, dimension: '3D', });
    }
  }
};

/**
 * 雷达数据显示
 * @return {void}
 */
const radarDataShow = () => {
  if (openName.value) {
    const endTime = moment().format('YYYYMMDDHH');
    const startTime = moment().add(-3, 'days').format('YYYYMMDD00');
    const params = {
      startTime: StartTime.value,
      endTime: EndTime.value,
    };
    const params2 = {
      startTime,
      endTime,
    };

    store.dispatch('layerConsole/getRadarData', params);
    store.dispatch('layerConsole/getWindyIssues', params2);

    legendName.value = 'RADAR';
  } else {
    store.commit('layerConsole/setIndexName', '');
  }
};

const active = ref<boolean>(false);

onMounted(() => {
  const endTime = moment().format('YYYYMMDDHH');
  const startTime = moment().add(-3, 'days').format('YYYYMMDD00');
  const params = {
    startTime: moment().subtract(12, 'hour').format('YYYYMMDDHHmm'),
    endTime: moment().format('YYYYMMDDHHmm'),
    indexName: legendName.value,
    // 数据来源
    type: sourceType.value,
    // 地球纬度
    queryType: 1,
  };
  const params2 = {
    startTime,
    endTime,
  };

  getPlayTimeLength();
  store.dispatch('layerConsole/getHistoryData', params);
  store.dispatch('layerConsole/getWindyIssues', params2);

  // handleItemClick('AQI', 'AQI');

  /*
   *  环境站点加载
   * store.dispatch('layerConsole/getEnvironmentStationList', { regionId: '', });
   */
  const stationParams = {
    startTime: moment().add(-3, 'hours').format('YYYYMMDDHH'),
    endTime: moment().format('YYYYMMDDHH'),
  };

  loadStationData(stationParams);
});
onUnmounted(() => {
  store.commit('layerConsole/setIndexName', 'PM25');
  store.commit('layerConsole/setType', 1);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["title-icon", openName.value === 'point' ? 'active' : ''])
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass(["title-icon2", openName.value === 'point' ? 'active' : ''])
        }, null, 2),
        _createElementVNode("ul", {
          class: _normalizeClass(["list-content", openName.value === 'point' ? 'sateOpen' : ''])
        }, [
          _createElementVNode("li", {
            class: "item title",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (handleOpen('point', _unref(menuConfig)[1].key)))
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["label title-label", openName.value === 'point' ? 'active' : ''])
            }, _toDisplayString(_unref(menuConfig)[1].label), 3),
            _createElementVNode("i", {
              class: _normalizeClass(["iconfont", _unref(menuConfig)[1].icon]),
              style: {"color":"#fff"}
            }, null, 2)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuConfig)[1].clidren, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "item",
              key: item.type,
              onClick: ($event: any) => (handleItemClick(item.param, item.type))
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(activeItem.value === item.param ? 'item-active' : '')
              }, null, 2),
              _createElementVNode("span", {
                class: "label",
                innerHTML: item.label
              }, null, 8, _hoisted_5),
              _createElementVNode("span", {
                class: _normalizeClass(["iconfont", [item.icon, activeItem.value === item.param ? 'active' : '']])
              }, null, 2)
            ], 8, _hoisted_4))
          }), 128))
        ], 2)
      ]),
      _createElementVNode("li", _hoisted_6, [
        _createElementVNode("div", {
          class: _normalizeClass(["title-icon", openName.value === 'satellite' ? 'active' : ''])
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass(["title-icon2", openName.value === 'satellite' ? 'active' : ''])
        }, null, 2),
        _createElementVNode("ul", {
          class: _normalizeClass(["list-content", openName.value === 'satellite' ? 'sateOpen' : ''])
        }, [
          _createElementVNode("li", {
            class: "item title",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (handleOpen('satellite', _unref(menuConfig)[0].key)))
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["label title-label", openName.value === 'satellite' ? 'active' : ''])
            }, _toDisplayString(_unref(menuConfig)[0].label), 3),
            _createElementVNode("i", {
              class: _normalizeClass(["iconfont", _unref(menuConfig)[0].icon]),
              style: {"color":"#fff"}
            }, null, 2)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuConfig)[0].clidren, (item) => {
            return _withDirectives((_openBlock(), _createElementBlock("li", {
              class: "item",
              key: item.type,
              onClick: ($event: any) => (handleItemClick(item.param, item.type))
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(activeItem.value === item.param ? 'item-active' : '')
              }, null, 2),
              _createElementVNode("span", {
                class: "label",
                innerHTML: item.label
              }, null, 8, _hoisted_8),
              _createElementVNode("span", {
                class: _normalizeClass(["iconfont", [item.icon, activeItem.value === item.param ? 'active' : '']])
              }, null, 2)
            ], 8, _hoisted_7)), [
              [_vShow, item.type !== 'H8']
            ])
          }), 128))
        ], 2)
      ]),
      _createElementVNode("li", _hoisted_9, [
        _createElementVNode("div", {
          class: _normalizeClass(["title-icon2", openName.value === 'RADAR' ? 'active' : ''])
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass(["title-icon", openName.value === 'RADAR' ? 'active' : ''])
        }, null, 2),
        _createElementVNode("ul", {
          class: "list-content",
          onClick: radarDataShow
        }, [
          _createElementVNode("li", {
            class: "item title",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (handleOpen('RADAR', _unref(menuConfig)[2].key)))
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["label title-label", openName.value === 'RADAR' ? 'active' : ''])
            }, _toDisplayString(_unref(menuConfig)[2].label), 3),
            _createElementVNode("i", {
              class: _normalizeClass(["iconfont", _unref(menuConfig)[2].icon]),
              style: {"color":"#fff"}
            }, null, 2)
          ])
        ])
      ]),
      _createElementVNode("li", _hoisted_10, [
        _createElementVNode("div", {
          class: _normalizeClass(["title-icon", openName.value === 'weather' ? 'active' : ''])
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass(["title-icon2", openName.value === 'weather' ? 'active' : ''])
        }, null, 2),
        _createElementVNode("ul", {
          class: _normalizeClass(["list-content", openName.value === 'weather' ? 'weatherOpen' : ''])
        }, [
          _createElementVNode("li", {
            class: "item title",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (handleOpen('weather', _unref(menuConfig)[3].key)))
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["label title-label", openName.value === 'weather' ? 'active' : ''])
            }, _toDisplayString(_unref(menuConfig)[3].label), 3),
            _createElementVNode("i", {
              class: _normalizeClass(["iconfont", _unref(menuConfig)[3].icon]),
              style: {"color":"#fff"}
            }, null, 2)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuConfig)[3].clidren, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "item",
              key: item.type,
              onClick: ($event: any) => (handleItemClick(item.param, item.type))
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(activeItem.value === item.param ? 'item-active' : '')
              }, null, 2),
              _createElementVNode("span", {
                class: "label",
                innerHTML: item.label
              }, null, 8, _hoisted_12),
              _createElementVNode("span", {
                class: _normalizeClass(["iconfont", [item.icon, activeItem.value === item.param ? 'active' : '']])
              }, null, 2)
            ], 8, _hoisted_11))
          }), 128))
        ], 2)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["legend", legendName.value])
    }, null, 2)
  ]))
}
}

})